import React from 'react';
import withTheme from '../../common/withTheme';
import { Link } from '@paypalcorp/pp-react';
import { get } from 'lodash';
import { parseMessages } from '../../utilityHelper';
import { getCdnHostName } from '@paypalcorp/instance-location';
const propertyInfo = parseMessages("common/header-ppgf");

const MinimalHeader = () => {

    return (
        <div style={{
            verticalAlign: 'middle',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0.5rem 0'
        }}><Link href="/">
                <img width='150' src={`https://${getCdnHostName()}/paypal-ui/logos/svg/paypal-monotone-transparent.svg`} alt={get(propertyInfo, 'header.logo')} />
            </Link></div>
    )
}
export default withTheme(MinimalHeader);